<!-- this component is not yet fully implemented -->
<template>
  <div>
    Type
    <a-select v-model="value">
      <a-select-option v-for="(value, index) in options" :key="taskSettingKey" :value="index">
        {{ value }}
      </a-select-option>
    </a-select>

    <div v-if="isUserDepartement">

      Afdeling
      <a-select :key="taskSettingKey" v-model="chosenDepartments" mode="tags">
        <a-select-option v-for="department in departments" :key="department.id" :value="department.name">
          {{ department.name }}
        </a-select-option>
      </a-select>
    </div>

  </div>
</template>

<script>
import TaskTargetEnum from "../../enums/TaskTargetEnum";
import UserDepartmentApi from '~/api/user_department'

export default {
  name: "TaskTargetComponent",
  props: {
    taskSettingKey: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      value: null,
      chosenDepartments: [],
      options: {
        [TaskTargetEnum.ADVISOR]: "Adviseur",
        [TaskTargetEnum.ACCOUNT_MANAGER]: "Behandelaar",
        [TaskTargetEnum.ADVISOR_AND_ACCOUNT_MANAGER]: "Adviseur en behandelaar",
        [TaskTargetEnum.USER_DEPARTMENTS]: "Afdeling"
      },
      departments: {
      },
    };
  },
  mounted() {
    UserDepartmentApi.index().then( response => () => {
      this.departments = response.data;
        }
    )
  },
  computed: {
    isUserDepartement() {
      return this.value === TaskTargetEnum.USER_DEPARTMENTS;
    },
  }
};
</script>

<style scoped>

</style>
